import React from 'react';
import AreaDetailPage from './AreaDetailPage';
import { hotelAreas } from '../data/mapData';

function HotelArea({ area }) {
  const config = hotelAreas[area] || hotelAreas.lobby;
  return <AreaDetailPage config={config} sectionHeader="Hotel" />;
}

export default HotelArea;
